<template>
  <div
    class="ugc-container"
    @scroll="bindScroll"
    :class="{ 'ugc-container-scroll': scroll }"
  >
    <div class="ugc-wrapper">
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      <div v-if="data" class="ugc-list">
        <UgcItem
          v-for="(item, index) in data"
          :key="index"
          :data="item"
        ></UgcItem>
        <div class="empty" v-if="data && !data.length">
          <img
            class="empty-image"
            src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
            alt=""
          />
          <div class="empty-text">暂无动态</div>
        </div>
        <img
          v-if="finished"
          class="gray-logo"
          src="https://btw-common-data.betterwestar.com/btw-admin/resource/105e8b8098652ec924de3cec5ec06d35_wh=390_33.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import UgcItem from './ugc-item.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  components: { UgcItem, WxOpenLaunchApp },
  props: {
    storeId: {
      type: [String, Number, undefined],
      default: undefined
    },
    scroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      finished: false,
      data: null,
      page: 1,
      extinfo: ''
    }
  },
  computed: {},
  created() {
    let url = location.origin + location.pathname
    this.extinfo = '/web?url=' + encodeURIComponent(url)
    this.onLoad()
  },
  methods: {
    bindScroll(e) {
      let el = e.target
      var scroll = e.target.scrollTop
      let isBottom = scroll >= el.scrollHeight - el.offsetHeight - 100
      if (isBottom && !this.loading && !this.finished) {
        this.onLoad()
      }
    },
    async onLoad() {
      this.loading = true
      let params = {
        page_size: 20,
        page: this.page,
        store_id: this.storeId,
        is_disclosure: this.$betterwe.isApp() ? 0 : 1 //是否公开
      }
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/getSelectMoment', params)
        .catch((e) => {})
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data.data.length) {
            this.page++
            this.data = (this.data || []).concat(res.data.data)
          } else {
            if (!this.data) {
              this.data = []
            }
            this.finished = true
          }
        } else {
          this.finished = true
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.ugc-container {
  height: 100%;
  // overflow-y: scroll;
  ::v-deep .van-list__finished-text {
    display: none;
  }
}
.ugc-container-scroll {
  overflow-y: scroll;
}
.ugc-wrapper {
  padding-top: 5px;
  overflow: hidden;
  position: relative;
}
.ugc-list {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.gray-logo {
  margin: 8px auto 50px;
  width: 130px;
  height: 11px;
  object-fit: contain;
}
.empty {
  width: 100%;
  height: 272px;
  background: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .empty-image {
    width: 214px;
    height: 112px;
    object-fit: contain;
    margin-bottom: 25px;
  }
  .empty-text {
    font-weight: bold;
    font-size: 16px;
    color: rgba(5, 11, 39, 0.5);
    line-height: 22px;
  }
}
</style>
